import React, {  } from 'react'
import { Route, Routes, BrowserRouter } from 'react-router-dom'
import styled from 'styled-components'
import { Box, ComponentsProvider, MessageBar } from '@looker/components'

import { Main } from './Components/Main/Main'

export enum ROUTES {
  APP_HOME = '/',
  APP_HOME_PARAMS = '/:params',
  CONFIG_ROUTE = '/config',
}

export const Framework: React.FC<any> = ({
  route,
  routeState,
}) => {

  return (
      <BrowserRouter>
        <Routes>
          <Route path={ROUTES.APP_HOME} element={<Main />} />
          {/* <Route path={ROUTES.APP_HOME}>
            <Home />
          </Route> */}
        </Routes>
      </BrowserRouter>
  )
}

export const Layout = styled(Box as any)`
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 200px auto;
  width: 100vw;
`
